import { Area } from '@espoon-voltti/nuora-domain/applicants'

import { t } from '../i18n'

export const formatOrgAreas = (areas: Area[]) =>
  areas.map((area) => t(['org', 'areas', 'values', area])).join(', ')
